<template>
    <lv-base-column ref="column" v-bind="columnBinding">
        <template slot-scope="{row,rowIndex,col,colIndex,editRow,fixedRow,}">
            <link-table-column-textarea-item
                    :row="row"
                    :edit-row="editRow"
                    :row-index="rowIndex"
                    :col="col"
                    :col-index="colIndex"
                    :fixed-row="fixedRow"
					:maxlength="maxlength"
					:showWordLimit="showWordLimit"
                    v-bind="columnItemBinding"
                    @click="lv_clickItem"
            />
        </template>
    </lv-base-column>
</template>

<script>
    import LvBaseColumn from "../../table/lv-base-column";
    import LinkTableColumnTextareaItem from "./link-table-column-textarea-item";
    import {ColumnMixin} from "../mixins";
    export default {
        name: "link-table-column-textarea",
        components: {LinkTableColumnTextareaItem, LvBaseColumn},
        mixins:[ColumnMixin],
        props:{
            showInDialog: {default: true},
            link: {default: true},
          	maxlength: Number,
          	showWordLimit: Boolean,
        },
    }
</script>

<style lang="scss">

</style>
